import update from 'react/lib/update';

const initialState = {
	isFetching: false,
	list: []
};

export default function shapes(state = initialState, action) {
	
	switch (action.type) {			

		case "IS_FETCHING_SHAPES":
			return update(state, { isFetching: { $set: action.bool } });

		case "SET_SHAPES":
			return update(state, { list: { $set: action.shapes } });		

		default:
			return state;
	}
}

export const groupShapes = (shapes, idbyproj = -1) => {
	let projeto = -1;
	const fullUrl = window.location.href;
	// TODO mudar isso pra um state
	if ( fullUrl.includes("mariana")) {
		projeto = 1;
	} else if (fullUrl.includes("brumadinho")) {
		projeto = 2;
	} else {
		//capturo o id
		if (idbyproj !== -1) {
			projeto = idbyproj;
		}
	}

	if (projeto !== -1) {
		return {
			predefined: {
				sectors: shapes.filter((shape) => (shape.shapeType === 5 && shape.projeto === projeto )),
				localities: shapes.filter((shape) => (shape.shapeType === 4 && shape.projeto === projeto )),
				samplingPoints: shapes.filter((shape) => (shape.shapeType === 6 && shape.projeto === projeto))	
			},
			custom: {}		
		};
	} else {
		return {
			predefined: {
				sectors: shapes.filter((shape) => (shape.shapeType === 5 )),
				localities: shapes.filter((shape) => (shape.shapeType === 4 )),
				samplingPoints: shapes.filter((shape) => (shape.shapeType === 6 ))	
			},
			custom: {}		
		};
	}

};


// WEBPACK FOOTER //
// ./src/state/domains/shapes/reducer.js